export const API_URL = process.env.REACT_APP_API_URL;
export const isMockApi = API_URL === 'mock';

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
